module.exports = __webpack_public_path__ + "static/media/connect.43aa138e.png";